import type { AccountHistoryFromBackend } from './types';

import type { ServiceConfig } from 'app/api';

import { URL } from '../../constants';
import { defaultRequestService } from '../../utils/default-request-service';

export const getAccountHistory = (
  config: ServiceConfig,
  range: { startDate: string; endDate: string },
) => {
  type AdapterProps = { response: AccountHistoryFromBackend[] };
  const url = `${URL.ACCOUNT_HISTORY}?startDate=${range.startDate}&endDate=${range.endDate}`;

  return defaultRequestService<AdapterProps>(url, config.instance.get);
};
